module.exports = __webpack_public_path__ + "static/media/ic_kappaletavarakuljetus_a.ca501395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_kappaletavarakuljetus_a.svg
// module id = 1166
// module chunks = 0